export default __webpack_public_path__ + "static/media/Mascota-segura.a5de6a41.svg";